import { Icon } from '@chakra-ui/react';

export const CarouselRecedeIcon = ({ color = 'action' }: { color?: string }) => (
	<Icon
		width="32px"
		height="31px"
		viewBox="0 0 32 31"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<circle
			cx="16.2163"
			cy="15.3302"
			r="14.4992"
			stroke={color}
			strokeWidth="1.66195"
		/>
		<path
			d="M18.449 20.446L13.0178 15.1257L18.449 9.80536"
			stroke="text"
			strokeWidth="1.66195"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
	</Icon>
);
